import { i18n } from '@/i18n';
import { UpdateToApprovedMenuItems } from '../entities/updateToApprovedMenu';

/**
 * 承認済に更新メニュー用のサービス
 */
export class UpdateToApprovedMenuService {
  /**
   * 承認済に更新メニューの表示名を取得する
   * @param item - 承認済に更新メニューの項目
   */
  static getDisplayText = (item: UpdateToApprovedMenuItems): string => {
    const t = i18n.t;
    switch (item) {
      case 'UpdateToApproved':
        return t('承認済に更新');
      case 'DeleteApprovalRequest':
        return t('承認依頼を削除');
      default:
        return t('');
    }
  };
}
